import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, Fragment as _Fragment, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex","align-items":"center","padding":"10px 20px"} }
const _hoisted_2 = { style: {"padding-right":"10px"} }
const _hoisted_3 = {
  key: 0,
  class: "progress",
  style: {"height":"2px","margin":"0 auto"}
}
const _hoisted_4 = { class: "custom_modal__header" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "custom_modal__body" }
const _hoisted_8 = {
  key: 1,
  style: {"margin":"10% auto 15%"}
}
const _hoisted_9 = {
  key: 0,
  class: "loader"
}
const _hoisted_10 = {
  key: 1,
  style: {"font-size":"22px","text-align":"center"}
}
const _hoisted_11 = {
  key: 2,
  class: "progress",
  style: {"height":"2px","width":"50vh","margin":"0 auto"}
}
const _hoisted_12 = { class: "custom_modal__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!

  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (_ctx.show)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            style: _normalizeStyle(_ctx.modalContainerStyle),
            class: "custom_modal"
          }, [
            (_ctx.loadingWithoutModal)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  ref: "loading",
                  style: _normalizeStyle(_ctx.modalLoadingStyle),
                  class: "loading-div"
                }, [
                  _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_loader)
                    ]),
                    _createElementVNode("div", null, _toDisplayString(_ctx.loadingText), 1)
                  ]),
                  (_ctx.progressBar !== 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("div", {
                          style: _normalizeStyle('width: ' + _ctx.progressBar + '%;'),
                          "aria-valuemax": "100",
                          "aria-valuemin": "0",
                          "aria-valuenow": "25",
                          class: "progress-bar",
                          role: "progressbar"
                        }, null, 4)
                      ]))
                    : _createCommentVNode("", true)
                ], 4))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "custom_modal__backdrop",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.requestClose && _ctx.requestClose(...args)))
            }),
            _createElementVNode("div", {
              ref: "dialog",
              class: _normalizeClass([_ctx.modalClass, "custom_modal__dialog"]),
              style: _normalizeStyle(_ctx.modalDialogStyle)
            }, [
              _renderSlot(_ctx.$slots, "header-container", {}, () => [
                _createElementVNode("div", _hoisted_4, [
                  (!_ctx.state.loading)
                    ? _renderSlot(_ctx.$slots, "header", { key: 0 })
                    : (_openBlock(), _createElementBlock("h4", _hoisted_5, "   ")),
                  _createElementVNode("button", {
                    class: "close",
                    type: "button",
                    disabled: _ctx.preventClose,
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.requestClose && _ctx.requestClose(...args)))
                  }, [...(_cache[2] || (_cache[2] = [
                    _createElementVNode("i", { class: "fas fa-times" }, null, -1)
                  ]))], 8, _hoisted_6)
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                (_ctx.state.loading && _ctx.loadingWithoutModal)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
                  : (_ctx.state.loading && !_ctx.loadingWithoutModal)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        (!_ctx.skipSpinner)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9))
                          : _createCommentVNode("", true),
                        (_ctx.loadingText !== '')
                          ? (_openBlock(), _createElementBlock("h4", _hoisted_10, _toDisplayString(_ctx.loadingText), 1))
                          : _createCommentVNode("", true),
                        (_ctx.progressBar !== 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _createElementVNode("div", {
                                style: _normalizeStyle('width: ' + _ctx.progressBar + '%;'),
                                "aria-valuemax": "100",
                                "aria-valuemin": "0",
                                "aria-valuenow": "25",
                                class: "progress-bar",
                                role: "progressbar"
                              }, null, 4)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _renderSlot(_ctx.$slots, "body", { key: 2 })
              ]),
              _createElementVNode("div", _hoisted_12, [
                (!_ctx.state.loading)
                  ? _renderSlot(_ctx.$slots, "footer", { key: 0 })
                  : _createCommentVNode("", true)
              ])
            ], 6)
          ], 4))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}